import { IMG_HOSTING, isMainPackage } from './domain';

// 上传地址 https://image-tools.mytestdrama.com/index.html

export const IMG_HOSTING_URLS = {
    WALLET_CARD_BG: `${IMG_HOSTING}1679940ee99ea515bf047d8501c67876.png`,
    MY_CARD_BG: `${IMG_HOSTING}e7a406620c12082a000bd63a66d6d815.png`,
    COINS_28: `${IMG_HOSTING}dcd6669101a8d9d0ac9a18c92809992c.png`,
    COINS_24: `${IMG_HOSTING}3c58ef011abdb2619c16cb611bdaad24.png`,
    COINS_20: `${IMG_HOSTING}4c55cd4da1cf90074deaf703d9cdcfcd.png`,
    BONUS_28: `${IMG_HOSTING}aaaf167eff7812473e739a7f55ebd8c9.png`,
    BONUS_24: `${IMG_HOSTING}b6ff56a4e6a2fd888a9bb49ff41af163.png`,
    BONUS_20: `${IMG_HOSTING}afa3d33fc27627a7b96eb05d2e42c558.png`,
    VIP_20: `${IMG_HOSTING}64ac5d9be230e8025c3acfee9974a66c.png`,
    BONUS_EXPIRED_22: `${IMG_HOSTING}f9ef73a76f800f218b32f9fa289891ff.png`,
    BONUS_LOCK: `${IMG_HOSTING}bbdebfb085704090118da54240075a70.png`,
    CANCEL_PAY_IMG_URL: `${IMG_HOSTING}bbdebfb085704090118da54240075a70.png`,
    PAYPAL_LOADING_LOGO: `${IMG_HOSTING}92046216db770fbf36e25e11c6c35a10.png`,
    PAYPAL_LOADING_SPINNER: `${IMG_HOSTING}ea75768d242ba3c6fe287a7372c42064.svg`,
    STRIPE_LOADING_CARD_LOGO: `${IMG_HOSTING}3870e3ad59d50f737a16fc5f8fbab1ce.png`,
    STRIPE_LOADING_CARD_SPINNER: `${IMG_HOSTING}5ac43be1b733540f1de9b0d51f2f6fce.svg`,
    STRIPE_LOADING_APPLE_LOGO: `${IMG_HOSTING}86d5d7c1fc92e1d152b1c2fac8943ea9.png`,
    STRIPE_LOADING_APPLE_SPINNER: `${IMG_HOSTING}7db695bff3aedf9c16ac8350dce88f75.svg`,
    STRIPE_LOADING_GOOGLE_LOGO: `${IMG_HOSTING}ac4c2320cf112eb17164318f67e5ebd6.png`,
    STRIPE_LOADING_GOOGLE_SPINNER: `${IMG_HOSTING}7abdda8097688f7305aba741e4cfaa17.svg`,
    PAYWALL_APPLE_PAY_ICON: `${IMG_HOSTING}c1646a212cb344f57582b64a12f4bdb2.svg`,
    PAYWALL_GOOGLE_PAY_ICON: `${IMG_HOSTING}4d21a34ea894b8a3b43baf42d6a8a6b2.svg`,
    PAYWALL_CARD_PAY_ICON: `${IMG_HOSTING}6fd2cf9baa8c359d52b50c61f2379fde.svg`,
    PAYWALL_APPLE_PAY_ICON_DARK: `${IMG_HOSTING}2bf44e03bd86bcb891718fd2466abe53.svg`,
    PAYWALL_CARD_PAY_ICON_DARK: `${IMG_HOSTING}1c6445ac67f245a6937c2ed13ff25a38.svg`,
    PAYWALL_PAYPAL_PAY_ICON_DARK: `${IMG_HOSTING}9fee0a65eeb1de1f936959c53619cb28.svg`,
    // 主包 / 分包占位图差异化，见下方赋值
    EMPTY_PLACEHOLDER: '',
};

if (isMainPackage()) {
    IMG_HOSTING_URLS.EMPTY_PLACEHOLDER = `${IMG_HOSTING}empty-placeholder.png`;
} else {
    IMG_HOSTING_URLS.EMPTY_PLACEHOLDER = `${IMG_HOSTING}ae64e36dd48c02965bb51edce13e03ab.png`;
}

/** 付费墙社会证明假头像池（CDN 图，随机取 5 张叠放展示） */
export const PAYWALL_FAKE_AVATARS: string[] = Array.from(
    { length: 10 },
    (_, i) => `${IMG_HOSTING}avatar-${String(i + 1).padStart(2, '0')}.jpg`
);
